module.exports = __webpack_public_path__ + "img/20200609_141738.95f538ec.jpg";